import { LegalLayout, Section } from './LegalLayout';

/**
 * Public Terms of Service. Required by Twilio toll-free verification: the
 * opt-in page must link to working Terms and Privacy pages. Every section
 * below maps to something a carrier reviewer checks — program description,
 * frequency, rates, HELP/STOP, carrier non-liability, contact.
 */
export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" updated="August 27, 2026">
      <Section heading="About this messaging program">
        <p>
          North American Dismantling Corp. (&ldquo;NADC&rdquo;, &ldquo;we&rdquo;) operates a text
          message program that sends employees their weekly work schedule. Messages list your
          assigned jobs, dates, start times, and meeting locations for the coming week, along with a
          link to your full schedule. You may reply <b>YES</b> to confirm you will be there or{' '}
          <b>NO</b> if you cannot make it.
        </p>
        <p>
          This program is for current NADC employees only. We do not send marketing or promotional
          messages through it.
        </p>
      </Section>

      <Section heading="Signing up">
        <p>
          You join by submitting the text message sign-up form and ticking the consent box, or by
          signing the text message authorization in your onboarding paperwork. Consent is not a
          condition of employment, and you may decline without any effect on your job.
        </p>
      </Section>

      <Section heading="Message frequency">
        <p>
          Message frequency varies with your schedule. Most weeks you will receive one message, up
          to about five messages per month.
        </p>
      </Section>

      <Section heading="Cost">
        <p>
          <b>Message and data rates may apply.</b> NADC does not charge for these messages, but your
          mobile carrier may charge you for sending or receiving them depending on your plan. Check
          with your carrier if you are unsure.
        </p>
      </Section>

      <Section heading="Stopping messages">
        <p>
          Reply <b>STOP</b> to any message to stop receiving them. We will stop, and we will not
          start again unless you sign up once more yourself. An opt-out stays in effect even if your
          phone number is later updated in our records.
        </p>
        <p>
          Reply <b>HELP</b> to any message for assistance, or contact the office using the details
          below.
        </p>
      </Section>

      <Section heading="Supported carriers and delivery">
        <p>
          Message delivery depends on your mobile carrier and is not guaranteed. Carriers are not
          liable for delayed or undelivered messages. A schedule text is a convenience, not the
          official record — if you do not receive one, contact the office.
        </p>
        <p>
          These messages can only be received on a mobile phone. A landline will accept a message
          and never deliver it, so please give us a mobile number.
        </p>
      </Section>

      <Section heading="Your responsibilities">
        <p>
          Give us a mobile number that belongs to you, and tell the office if it changes or if you
          stop using it. Do not sign up a number that is not yours.
        </p>
      </Section>

      <Section heading="Changes to these terms">
        <p>
          We may update these terms. The date at the top of this page shows when they last changed.
          Continuing to receive messages after a change means you accept the updated terms.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          North American Dismantling Corp.
          <br />
          Email: <a className="text-safety-400 underline hover:text-safety-300" href="mailto:mikeperry@nadc1.com">mikeperry@nadc1.com</a>
          <br />
          Web: <a className="text-safety-400 underline hover:text-safety-300" href="https://nadc1.com">nadc1.com</a>
        </p>
      </Section>
    </LegalLayout>
  );
}

export default TermsPage;
